import { apiRequest } from '../utils/api';

export const getStaffSafetyItems = async (propertyId, resource) => {
  if (!propertyId) return [];
  const response = await apiRequest(`/api/staff-safety/properties/${propertyId}/${resource}`);
  return response?.items || [];
};
